import { Hammer } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

interface ComingSoonProps {
  title: string;
  phase: string;
  summary: string;
}

export function ComingSoon({ title, phase, summary }: ComingSoonProps) {
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
        <p className="text-sm text-muted-foreground">{summary}</p>
      </div>
      <Card>
        <CardContent className="flex items-center gap-4 p-6">
          <Hammer className="h-6 w-6 text-muted-foreground" />
          <div>
            <div className="font-medium">Coming in {phase}</div>
            <div className="text-sm text-muted-foreground">
              Backend infrastructure exists. UI not yet built.
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
